/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getMensesEvents } from 'app/entities/menses-event/menses-event.reducer';
import { CycleStatus } from 'app/shared/model/enumerations/cycle-status.model';
import { createEntity, getEntity, reset, updateEntity } from './ovulation.reducer';

export const OvulationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const mensesEvents = useAppSelector(state => state.mensesEvent.entities);
  const ovulationEntity = useAppSelector(state => state.ovulation.entity);
  const loading = useAppSelector(state => state.ovulation.loading);
  const updating = useAppSelector(state => state.ovulation.updating);
  const updateSuccess = useAppSelector(state => state.ovulation.updateSuccess);
  const cycleStatusValues = Object.keys(CycleStatus);

  const handleClose = () => {
    navigate(`/ovulation${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getMensesEvents({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.estimatedStartDate !== undefined && typeof values.estimatedStartDate !== 'number') {
      values.estimatedStartDate = Number(values.estimatedStartDate);
    }
    if (values.actualStartDate !== undefined && typeof values.actualStartDate !== 'number') {
      values.actualStartDate = Number(values.actualStartDate);
    }
    if (values.estimatedEndDate !== undefined && typeof values.estimatedEndDate !== 'number') {
      values.estimatedEndDate = Number(values.estimatedEndDate);
    }
    if (values.actualEndDate !== undefined && typeof values.actualEndDate !== 'number') {
      values.actualEndDate = Number(values.actualEndDate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...ovulationEntity,
      ...values,
      event: mensesEvents.find(it => it.id.toString() === values.event?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          status: 'ESTIMATED',
          ...ovulationEntity,
          event: ovulationEntity?.event?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.ovulation.home.createOrEditLabel" data-cy="OvulationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.ovulation.home.createOrEditLabel">Create or edit a Ovulation</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="ovulation-id"
                  label={translate('tinyMedicRestApp.ovulation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.estimatedStartDate')}
                id="ovulation-estimatedStartDate"
                name="estimatedStartDate"
                data-cy="estimatedStartDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.actualStartDate')}
                id="ovulation-actualStartDate"
                name="actualStartDate"
                data-cy="actualStartDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.estimatedEndDate')}
                id="ovulation-estimatedEndDate"
                name="estimatedEndDate"
                data-cy="estimatedEndDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.actualEndDate')}
                id="ovulation-actualEndDate"
                name="actualEndDate"
                data-cy="actualEndDate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.status')}
                id="ovulation-status"
                name="status"
                data-cy="status"
                type="select"
              >
                {cycleStatusValues.map(cycleStatus => (
                  <option value={cycleStatus} key={cycleStatus}>
                    {translate(`tinyMedicRestApp.CycleStatus.${cycleStatus}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.comments')}
                id="ovulation-comments"
                name="comments"
                data-cy="comments"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.active')}
                id="ovulation-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.draft')}
                id="ovulation-draft"
                name="draft"
                data-cy="draft"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.cursor')}
                id="ovulation-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.lastUpdated')}
                id="ovulation-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.microSec')}
                id="ovulation-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.ovulation.timestampEntry')}
                id="ovulation-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="ovulation-event"
                name="event"
                data-cy="event"
                label={translate('tinyMedicRestApp.ovulation.event')}
                type="select"
              >
                <option value="" key="0" />
                {mensesEvents
                  ? mensesEvents.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/ovulation" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default OvulationUpdate;
